import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56e3336e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modalBackdrop flex absolute z-max" }
const _hoisted_2 = { class: "c4c-modal" }
const _hoisted_3 = { class: "panelheader" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "headerTitle" }, "SMS Notifications", -1))
const _hoisted_5 = { "aria-hidden": "true" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "neu-tooltip--text" }, "Close", -1))
const _hoisted_7 = { class: "panleBody" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Current ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Activity Log ", -1))
const _hoisted_10 = {
  key: 0,
  id: "filters-details",
  class: "panelTabData scrollBar",
  role: "tabpanel"
}
const _hoisted_11 = {
  key: 1,
  id: "ED-surge-details",
  class: "panelTabData scrollBar",
  role: "tabpanel"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_neu_tab = _resolveComponent("neu-tab")!
  const _component_neu_tablist = _resolveComponent("neu-tablist")!
  const _component_CurrentNotifications = _resolveComponent("CurrentNotifications")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("a", {
          href: "#",
          class: "closeBtn neu-tooltip",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }, [
          _createElementVNode("i", _hoisted_5, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fas', 'close'],
              size: "lg"
            })
          ]),
          _hoisted_6
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_neu_tablist, {
          value: _ctx.activeTab,
          class: "mx-4 tabList"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_neu_tab, {
              white: "",
              tab: "current",
              onClick: _ctx.showCurrentTab
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_neu_tab, {
              white: "",
              tab: "activityLog",
              onClick: _ctx.showActivityLogTab
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["value"]),
        (_ctx.isCurrentNotification)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_component_CurrentNotifications, { notificationTab: _ctx.activeTab }, null, 8, ["notificationTab"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isActivityLog)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(_component_CurrentNotifications, { notificationTab: _ctx.activeTab }, null, 8, ["notificationTab"])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}